
import React from "react";
import { Table, Th, Thead, Tr, Td } from "reactable";
import { appHelpers } from "../../_helpers";
const PassengersDetails = ({ records }) => {
    const passengerSummary = Array.isArray(records.NewPassengersDetails)
    ? records.NewPassengersDetails
    : JSON.parse(records.NewPassengersDetails || "[]");  
    return (
      <div>
        <Table
          className="table table-striped table-hover"
          id="table"
        //   sortable={true}
          itemsPerPage={15}
          pageButtonLimit={10}
        >
          <Thead>
            <Th width={300} column="ManifestId">
              <span>Manifest ID</span>
            </Th>
            <Th width={300} column="ExtraPassengerCount">
              <span>Extra Passenger Count</span>
            </Th>
            <Th width={300} column="FlightNumber">
              <span>Flight Number</span>
            </Th>
            <Th width={300} column="Route">
              <span>Route</span>
            </Th>
            <Th width={300} column="Amount">
              <span>Amount</span>
            </Th>
          </Thead>
  
          {passengerSummary.map((item, i) => (
            <Tr key={i}>
              <Td column="ManifestId">{item.ManifestId}</Td>
              <Td column="ExtraPassengerCount">{item.ExtraPassengerCount}</Td>
              <Td column="FlightNumber">{item.FlightNumber}</Td>
              <Td column="Route">{item.Route}</Td>
              <Td column="Amount">
                {appHelpers.numberWithCommasOnly(item.Amount)}
              </Td>
            </Tr>
          ))}
        </Table>
      </div>
    );
  };
  
  export default PassengersDetails;
  


// WEBPACK FOOTER //
// ./src/views/unbillled-passengers/passenger-table.js